import { InvitedByProfile } from './profile';
import { Team } from './team';

// Invitation type enum
export enum InvitationType {
  Team = 'business',
}

export interface Invitation {
  type: InvitationType;
  id: string;
  invitedBy: InvitedByProfile;
  team: Team;
}
